/**
 * "Retry" for a failed or cancelled transfer row.
 *
 * Kept OUT of the store on purpose: a retry closes over what started the
 * transfer — for an OS drop that is the browser `File` itself — and the store
 * is plain data that Rust progress events are merged into. Entries are pruned
 * whenever the strip drops a row, so a cleared upload does not keep its File
 * alive.
 */
const retries = new Map(); // transferId → () => void

export function registerRetry(transferId, fn) {
  if (transferId && typeof fn === 'function') retries.set(transferId, fn);
}

export const canRetry = (transferId) => retries.has(transferId);

/** Run the retry once; the old row is the caller's to remove. */
export function runRetry(transferId) {
  const fn = retries.get(transferId);
  retries.delete(transferId);
  if (fn) fn();
  return !!fn;
}

/** Forget every retry whose row is gone. */
export function pruneRetries(liveIds) {
  const keep = new Set(liveIds);
  for (const id of [...retries.keys()]) if (!keep.has(id)) retries.delete(id);
}
